import React from 'react';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import * as Icon from 'react-bootstrap-icons';
import { toast } from 'react-toastify';

import { useSpdCore } from '../../../common/hooks/useSpdCore';
import { responseErrors } from '../../../common/spdCore/validation/responseErrors';
import ConfirmationButton from '../../../app/components/ConfirmationButton';
import { ResponseError } from '../../../common/spdCore/autogenerated/spdApiClient';

export const IndicatorTestBinLink = (props: {
  indicatorTestId: string;
  setRefresh?: () => void;
}) => {
  const spd = useSpdCore();

  const handleClick = async () => {
    try {
      await spd.indicatorTests.delete(props.indicatorTestId);
      props.setRefresh?.();
    } catch (response) {
      const errors = await responseErrors(response as ResponseError);
      toast.error(`Nie udało się usunąć wskaźnika. ${errors.join(', ')}`);
    }
  };

  return (
    // eslint-disable-next-line jsx-a11y/no-static-element-interactions, jsx-a11y/click-events-have-key-events
    <div onClick={e => e.stopPropagation()}>
      <OverlayTrigger
        overlay={
          <Tooltip style={{ position: 'fixed' }}>Usunięcie wskaźnika</Tooltip>
        }
      >
        <ConfirmationButton
          className="ms-1"
          confirmation="Czy na pewno usunąć wskaźnik?"
          variant="btn-info"
          onOK={handleClick}
        >
          <Icon.Trash />
        </ConfirmationButton>
      </OverlayTrigger>
    </div>
  );
};
